export const normalizeHexColor = (color: string): string => {
  if (!color) return undefined;

  return color && color.toString().startsWith("#") ? color : `#${color}`;
};

export const stripHashFromHexColor = (color: string): string => {
  return color ? color.toString().replace("#", "") : color;
};
